/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PeriodType/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function PeriodType({
  children,
  viewPath = "/DesignSystem/ReportsKpiFilters/PeriodType",
  onChange
  
}) {
let tabSelectedFiltersPeriodTypesValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.filters.period_types',
})
let tabSelectedFiltersPeriodTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.filters.period_type_id',
})
let tabSelectedFiltersPeriodTypeIdChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected.filters.period_type_id',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 data="tab.selected.filters.period_types"
 from={tabSelectedFiltersPeriodTypesValueData}
 data="tab.selected.filters.period_type_id"
 onChange={tabSelectedFiltersPeriodTypeIdChangeData}
 value={tabSelectedFiltersPeriodTypeIdValueData}
 maxWidth={70}
 flexGrow={0}
 size="small"
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Period"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}